<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="类型">
                <a-select
                  v-model="queryParam.t"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option value="1">本月到期</a-select-option>
                  <a-select-option value="2">本月交租</a-select-option>
                  <a-select-option value="3">到期周期</a-select-option>
                  <a-select-option value="4">交租周期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24" v-if="queryParam.t">
              <a-form-model-item label="周期">
                <a-select
                  placeholder="请选择"
                  v-if="queryParam.t < 3"
                  v-model="queryParam.m"
                >
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="01">1月</a-select-option>
                  <a-select-option value="02">2月</a-select-option>
                  <a-select-option value="03">3月</a-select-option>
                  <a-select-option value="04">4月</a-select-option>
                  <a-select-option value="05">5月</a-select-option>
                  <a-select-option value="06">6月</a-select-option>
                  <a-select-option value="07">7月</a-select-option>
                  <a-select-option value="08">8月</a-select-option>
                  <a-select-option value="09">9月</a-select-option>
                  <a-select-option value="10">10月</a-select-option>
                  <a-select-option value="11">11月</a-select-option>
                  <a-select-option value="12">12月</a-select-option>
                </a-select>
                <a-range-picker
                  v-model="queryParam.dateRang"
                  v-if="queryParam.t >= 3"
                />
              </a-form-model-item>
            </a-col>
            <template v-if="advanced">
              <!-- <a-col :md="8" :sm="24">
                <a-form-model-item label="房号"
                  ><a-input
                    allowClear
                    v-model="queryParam.no"
                    placeholder="房号"
                /></a-form-model-item>
              </a-col> -->
              <a-col :md="8" :sm="24">
                <a-form-model-item label="姓名"
                  ><a-input
                    allowClear
                    placeholder="请输入姓名"
                    v-model="queryParam.realName"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="手机号码"
                  ><a-input
                    allowClear
                    v-model="queryParam.mobile"
                    placeholder="手机号码"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="小区">
                  <a-input
                    allowClear
                    ref="cn"
                    v-model="queryParam.communityName"
                    @change="onChange"
                    @click="onSearch"
                    placeholder="请选择小区"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="楼号"
                  ><a-input
                    allowClear
                    v-model="queryParam.buildingNo"
                    placeholder="楼号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="单元号"
                  ><a-input
                    allowClear
                    v-model="queryParam.unitNo"
                    placeholder="单元号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="门牌号"
                  ><a-input
                    allowClear
                    v-model="queryParam.houseNum"
                    placeholder="门牌号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="房号"
                  ><a-input
                    allowClear
                    v-model="queryParam.roomNum"
                    placeholder="房号"
                /></a-form-model-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :scroll="{ x: 2400 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="checkSta" slot-scope="text">
          <template>
            <a-tag class="render-tag" :color="text == 'R' ? '#f50' : '#87d068'"
              >{{ text == "R" ? "待审核" : "已审核" }}({{ text }})</a-tag
            >
          </template>
        </span>
        <span slot="sta" slot-scope="text">
          <template>
            <a-tag class="render-tag" v-if="text == 'L'" color="grey"
              >失效</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'R'" color="#737373"
              >待签约</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'I'" color="#87d068"
              >租约正常</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'S'" color="#ff6666"
              >租约到期</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'X'" color="orange"
              >租约取消</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'Z'" color="#108ee9"
              >转租</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'V'" color="red"
              >违约</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a-popconfirm
              title="确认违约吗？"
              @confirm="confirm('V', record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">违约</a>
            </a-popconfirm>
            <a-popconfirm
              title="确认转租吗？"
              @confirm="confirm('Z', record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">转租</a>
            </a-popconfirm>
            <a-popconfirm
              title="确认租约到期吗？"
              @confirm="confirm('S', record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">到期</a>
            </a-popconfirm>
            <a-popconfirm
              title="确认交租吗？"
              @confirm="confirm('I', record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">交租</a>
            </a-popconfirm>
            <a-popconfirm
                title="确认续约吗？"
                @confirm="createContract(record)"
                v-if="record.contractNo && record.checkSta != 'R' && record.sta == 'I'"
                okText="确认"
                cancelText="取消"
            >
              <a class="a-action">一键续租</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
    </a-card>
    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>
    <!-- 创建租约 -->
    <create-lease-form
        ref="createLeaseForm"
        @success="$refs.table.refresh(true)"
    ></create-lease-form>
  </page-view>
</template>
<script>
import { PageView } from "@/layouts";
import { STable } from "@/components";
import CommunityModal from "../house/stepForm/CommunityModal.vue";
import CreateLeaseForm from "./form/CreateLeaseForm.vue";
import { formatting, stringToDate } from "../../../utils/util.js";
export default {
  components: {
    PageView,
    STable,
    CommunityModal,
    CreateLeaseForm
  },
  name: "LeaseRentList",
  data() {
    return {
      userInfo: {},
      pageSize: 10,
      pageNumber: 1,
      advanced: false,
      queryParam: {
        t: "1",
        m: undefined,
        sta: "I",
        communityCode: "",
        communityName: ""
      },
      // 表头
      columns: [
        {
          title: "姓名",
          dataIndex: "realName",
          fixed: "left"
        },
        {
          title: "性别",
          dataIndex: "sex",
          fixed: "left"
        },
        {
          title: "手机号",
          dataIndex: "hideMobile",
          fixed: "left"
        },
        {
          title: "身份证号",
          dataIndex: "hideIdCardNo",
          fixed: "left"
        },
        {
          title: "房号",
          dataIndex: "no",
          width: 120
        },
        {
          title: "租约状态",
          dataIndex: "sta",
          width: 90,
          scopedSlots: { customRender: "sta" }
        },
        {
          title: "审核状态",
          dataIndex: "checkSta",
          width: 90,
          scopedSlots: { customRender: "checkSta" }
        },
        {
          title: "类型",
          dataIndex: "rentTypeName",
          width: 80
        },
        {
          title: "月租金(元)",
          dataIndex: "monthRent",
          width: 100
        },
        {
          title: "押金",
          dataIndex: "deposit",
          width: 100
        },
        {
          title: "付款方式",
          dataIndex: "payWayName",
          width: 100
        },
        {
          title: "开始时间",
          dataIndex: "startTime",
          width: 120
        },
        {
          title: "下次交租",
          dataIndex: "nextTime",
          width: 120
        },
        {
          title: "结束时间",
          dataIndex: "finishTime",
          width: 120
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          width: 220
        },
        {
          title: "签订时间",
          dataIndex: "contractTime",
          width: 200
        },
        {
          title: "修改人",
          dataIndex: "modifyUser"
        },
        {
          title: "修改时间",
          dataIndex: "modifyDatetime",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          width: 200,
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let searchParam = Object.assign(parameter, this.queryParam);
        //当前时间
        let date = new Date();
        let year = date.getFullYear().toString();
        let str = "";
        if (this.queryParam.m != "0") {
          str = year + "-" + this.queryParam.m;
        }
        if (this.queryParam.t == 2) {
          //本月交租
          if (this.queryParam.m > 0) {
            searchParam.nextTime = str + "-01 00:00:00";
            searchParam.nextTimeEnd = str + "-31 23:59:59";
          }
        } else if (this.queryParam.t == 1) {
          //本月到期
          if (this.queryParam.m > 0) {
            searchParam.finishTime = str + "-01 00:00:00";
            searchParam.finishTimeEnd = str + "-31 23:59:59";
          }
        } else if (this.queryParam.t == 3) {
          //到期周期
          if (this.queryParam.dateRang.length > 0) {
            let start = this.queryParam.dateRang[0].format("YYYY-MM-DD");
            let end = this.queryParam.dateRang[1].format("YYYY-MM-DD");
            searchParam.finishTime = start + " 00:00:00";
            searchParam.finishTimeEnd = end + " 23:59:59";
          }
        } else if (this.queryParam.t == 4) {
          //交租周期
          if (this.queryParam.dateRang.length > 0) {
            let start = this.queryParam.dateRang[0].format("YYYY-MM-DD");
            let end = this.queryParam.dateRang[1].format("YYYY-MM-DD");
            searchParam.nextTime = start + " 00:00:00";
            searchParam.nextTimeEnd = end + " 23:59:59";
          }
        }
        return this.$http.roomBksApi
          .pageHouseUserLease(searchParam)
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
    if (this.userInfo.userType == "2") {
      this.queryParam.keeperUserNo = this.userInfo.userNo;
    }
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam = { t: "1", m: undefined, sta: "I" };
      this.queryParam.merchantNo = this.userInfo.merchantNo;
      if (this.userInfo.userType == "2") {
        this.queryParam.keeperUserNo = this.userInfo.userNo;
      }
    },
    /**
     * 创建租约
     * @param {Object} item
     */
    createContract(item) {
      item.personalInfo = {
        realName: item.realName,
        sex: item.sex,
        mobile: item.mobile,
        idcard: item.idCardNo,
      };
      this.$refs.createLeaseForm.show(item);
    },
    confirm(type, item) {
      // I交租 S到期 Z转租 V违约
      let param = {};
      param.id = item.id;
      param.leaseNo = item.leaseNo;
      param.sta = type;
      param.businessType = "modify";
      this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
        if (res.result == 0) {
          this.$message.success("处理成功");
          this.$refs.table.refresh(true);
        }
      });
    },
    onChange(evt) {
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      this.queryParam.communityCode = item.communityCode;
      this.queryParam.communityName = item.communityName;
      this.$refs.cn.focus();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-actions {
  text-align: right;
}
/deep/ .ant-card-actions > li {
  float: none;
  width: auto !important;
  display: inline-block;
  margin-right: 10px;
}

.actions {
  button {
    margin-right: 10px;
  }
}
</style>
